import { Skeleton } from "@/components/ui/skeleton";

/**
 * Lightweight skeleton sized to the main content area.
 * Used as the local Suspense fallback inside the persistent dashboard shell
 * so the sidebar/topbar stay visible while a lazy page chunk loads.
 */
export function ContentSkeleton() {
  return (
    <div className="space-y-6 animate-in fade-in duration-200">
      {/* Header strip */}
      <div className="space-y-3">
        <Skeleton className="h-8 w-64" />
        <Skeleton className="h-4 w-96 max-w-full" />
      </div>

      {/* KPI row */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {Array.from({ length: 4 }).map((_, i) => (
          <Skeleton key={i} className="h-24 rounded-xl" />
        ))}
      </div>

      {/* Main panel */}
      <Skeleton className="h-72 rounded-xl" />
    </div>
  );
}
